import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'

export const useFormulaStore = storeWrapper('useFormulaStore', () => ({
  validateFormula: async ({ expression, clientNo = null, matterNo = null }) => {
    try {
      await ospreyAPI({
        service: 'matters',
        endpoint: 'Formula/Validate',
        data: { expression, clientNo, matterNo },
        suppressErrorToast: true
      })

      // the controller's success response currently has no body to read an evaluated result from
      return { isValid: true, message: null }
    } catch (err) {
      const message = typeof err?.response?.data === 'string' ? err.response.data : 'Formula is not valid'
      return { isValid: false, message }
    }
  }
}))
